// "Spot the Slip" expansion — IDENTITY theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_IDENTITY = [
  ["Yo soy aburrido en las fiestas largas.", "Yo estoy aburrido en las fiestas largas.", "ser-estar",
    "A passing mood (bored right now) takes estar; ser aburrido means 'boring'.", "ser-vs-estar"],
  ["Mi amiga es enferma hoy.", "Mi amiga está enferma hoy.", "ser-estar",
    "Being ill is a temporary condition → estar.", "ser-vs-estar"],
  ["Él es de Noruega pero está noruego desde siempre.", "Él es de Noruega y es noruego.", "ser-estar",
    "Nationality is an essential identity trait → ser, not estar.", "ser-vs-estar"],
  ["La mujer es muy simpático.", "La mujer es muy simpática.", "gender",
    "Adjectives agree with the noun: feminine subject → simpática.", "adjective-agreement"],
  ["Es una hombre alto.", "Es un hombre alto.", "gender",
    "Hombre is masculine; pair it with un, not una.", "gender-agreement-of-nouns"],
  ["Mi hermana es muy hablador.", "Mi hermana es muy habladora.", "gender",
    "A feminine subject needs the feminine form habladora.", "adjective-agreement"],
  ["Me llamo es Pablo.", "Me llamo Pablo.", "basics",
    "Llamarse already means 'to be called'; don't add es.", ""],
  ["Tengo treinta años viejo.", "Tengo treinta años.", "basics",
    "Age uses tener + años with no word for 'old'.", ""],
  ["A mí me gusta las personas educadas.", "A mí me gustan las personas educadas.", "gustar",
    "Gustar agrees with the thing liked; plural people → gustan.", "gustar-and-similar-verbs"],
  ["Ayer mi abuelo fallecía después de una larga vida.", "Ayer mi abuelo falleció después de una larga vida.", "preterito-imperfecto",
    "A single, completed event takes the pretérito → falleció.", "a2-preterito-vs-imperfecto"],
  ["Cuando era joven, fui muy tímido siempre.", "Cuando era joven, era muy tímido.", "preterito-imperfecto",
    "An ongoing trait in the past is imperfecto → era.", "a2-preterito-vs-imperfecto"],
  ["Mi caracter es tranquilo.", "Mi carácter es tranquilo.", "accents",
    "Carácter is llana ending in -r, so it carries a written accent.", "stress-and-written-accents"],
  ["Es bilingue en español e inglés.", "Es bilingüe en español e inglés.", "accents",
    "The diéresis on bilingüe marks that the u is pronounced.", "stress-and-written-accents"],
  ["Quiero que mi hijo es educado.", "Quiero que mi hijo sea educado.", "subjunctive",
    "A wish about someone else (querer que) triggers the subjunctive → sea.", "b1-present-subjunctive"],
  ["Es importante que tú te defines con honestidad.", "Es importante que tú te definas con honestidad.", "subjunctive",
    "Impersonal 'es importante que' takes the subjunctive → definas.", "b1-present-subjunctive"],
];
